namespace RioERP.Users {
    export namespace CustomerAddressService {
        export const baseUrl = 'Users/CustomerAddress';

        export declare function Create(request: Serenity.SaveRequest<CustomerAddressRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CustomerAddressRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CustomerAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RetrieveWithCustomerdetails(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CustomerAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CustomerAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Users/CustomerAddress/Create",
            Update = "Users/CustomerAddress/Update",
            Delete = "Users/CustomerAddress/Delete",
            Retrieve = "Users/CustomerAddress/Retrieve",
            RetrieveWithCustomerdetails = "Users/CustomerAddress/RetrieveWithCustomerdetails",
            List = "Users/CustomerAddress/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'RetrieveWithCustomerdetails', 
            'List'
        ].forEach(x => {
            (<any>CustomerAddressService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
